(function () {
  var selector = '[id^="ProductRecommendations-"][data-product-id]';
  var productCoreSelector = 'product-images, .product-block--price, .quantitybuyflex, form[action*="/cart/add"]';

  function getSectionId(section) {
    return section.dataset.sectionId || section.id.replace(/^ProductRecommendations-/, '');
  }

  function containsProductCore(element) {
    if (!element) {
      return false;
    }

    if (element.matches && element.matches(productCoreSelector)) {
      return true;
    }

    return !!element.querySelector(productCoreSelector);
  }

  function clearSection(section) {
    section.classList.add('product-recommendations-owned--empty');
    section.innerHTML = '<div class="product-recommendations-owned__empty" aria-hidden="true"></div>';
    section.dataset.loaded = 'true';
  }

  function removeSafeRecommendationsTarget(section) {
    var target = section.closest('.pdp-owned-recommendations-row');

    if (target && !containsProductCore(target)) {
      target.remove();
      return true;
    }

    target = section.closest('.product-recommendations-owned');

    if (target && !containsProductCore(target)) {
      target.remove();
      return true;
    }

    return false;
  }

  function hideSection(section) {
    var shopifySection = section.closest('.shopify-section');

    if (shopifySection && containsProductCore(shopifySection)) {
      if (section.getBoundingClientRect().top <= window.innerHeight) {
        clearSection(section);
        return;
      }

      if (removeSafeRecommendationsTarget(section)) {
        return;
      }

      clearSection(section);
      return;
    }

    if (section.getBoundingClientRect().top <= window.innerHeight) {
      clearSection(section);
      return;
    }

    if (removeSafeRecommendationsTarget(section)) {
      return;
    }

    clearSection(section);
  }

  function getEscapedId(id) {
    if (window.CSS && CSS.escape) {
      return CSS.escape(id);
    }

    return id.replace(/("|'|\\|\.|:|\[|\]|,|=|@)/g, '\\$1');
  }

  function getRecommendationBucket(element) {
    return (element.dataset.recommendationBucket || '').toLowerCase();
  }

  function getCardContainer(card) {
    return card.closest('.grid-item') || card.closest('is-land') || card;
  }

  // Keep these bucket rules in sync with snippets/product-recommendations-owned.liquid.
  function shouldKeepCard(section, card) {
    var currentBucket = getRecommendationBucket(section);
    var cardBucket = getRecommendationBucket(card);

    if (!currentBucket) {
      return true;
    }

    if (currentBucket === 'wine' || currentBucket === 'spirit') {
      return cardBucket === currentBucket;
    }

    return !cardBucket || cardBucket === currentBucket;
  }

  function filterFetchedCards(section, fetchedSection) {
    var cards = Array.prototype.slice.call(fetchedSection.querySelectorAll('[data-product-grid-item]'));
    var validCount = 0;

    cards.forEach(function (card) {
      if (shouldKeepCard(section, card)) {
        validCount++;
        return;
      }

      getCardContainer(card).remove();
    });

    return validCount;
  }

  function buildUrl(section) {
    var productId = section.dataset.productId;
    var sectionId = getSectionId(section);
    var limit = section.dataset.limit || '5';
    var intent = section.dataset.intent || 'related';
    var baseUrl = section.dataset.url || '/recommendations/products';

    if (!productId || !sectionId) {
      return null;
    }

    return baseUrl
      + '?section_id=' + encodeURIComponent(sectionId)
      + '&product_id=' + encodeURIComponent(productId)
      + '&limit=' + encodeURIComponent(limit)
      + '&intent=' + encodeURIComponent(intent);
  }

  async function loadSection(section) {
    if (!section || section.dataset.loaded === 'true') {
      return;
    }

    var url = buildUrl(section);

    if (!url) {
      console.warn('Owned product recommendations missing product or section id.');
      hideSection(section);
      return;
    }

    try {
      var response = await fetch(url);

      if (!response.ok) {
        console.warn('Owned product recommendations request failed:', response.status);
        hideSection(section);
        return;
      }

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fetchedSection = doc.querySelector('#' + getEscapedId(section.id)) || doc.querySelector('.product-recommendations-owned');
      var validProductCount = fetchedSection ? filterFetchedCards(section, fetchedSection) : 0;

      if (validProductCount < 2) {
        console.warn('Owned product recommendations returned fewer than 2 category-safe products.');
        hideSection(section);
        return;
      }

      section.innerHTML = fetchedSection.innerHTML;
      section.dataset.loaded = 'true';
    } catch (error) {
      console.warn('Owned product recommendations failed to load:', error);
      hideSection(section);
    }
  }

  function init(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(selector)) {
      loadSection(scope);
    }

    scope.querySelectorAll(selector).forEach(loadSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
